import { INSTANCE } from './endpoint';

const getToken = () => `Bearer ${localStorage.getItem('token')}`;

// ========== Types ==========

export type EmailProviderType = 'default' | 'sendgrid' | 'brevo';

export interface IEmailSettings {
  provider: EmailProviderType;
  apiKey?: string;
  fromEmail?: string;
  fromName?: string;
}

// ========== API ==========

export function getEmailSettings(programId: string): Promise<IEmailSettings> {
  return new Promise((resolve, reject) => {
    INSTANCE.get(`/v1/programs/${programId}/email-settings`, {
      headers: { Authorization: getToken() },
    })
      .then((res) => resolve(res.data?.data || { provider: 'default' }))
      .catch((error) => reject(error));
  });
}

export function updateEmailSettings(programId: string, settings: IEmailSettings): Promise<IEmailSettings> {
  return new Promise((resolve, reject) => {
    INSTANCE.put(`/v1/programs/${programId}/email-settings`, settings, {
      headers: { Authorization: getToken() },
    })
      .then((res) => resolve(res.data?.data))
      .catch((error) => reject(error));
  });
}

export function testEmailSettings(programId: string, recipientEmail: string): Promise<{ success: boolean; message: string }> {
  return new Promise((resolve, reject) => {
    INSTANCE.post(`/v1/programs/${programId}/email-settings/test`, { recipientEmail }, {
      headers: { Authorization: getToken() },
    })
      .then((res) => resolve(res.data))
      .catch((error) => reject(error));
  });
}
